// extracted by mini-css-extract-plugin
export default {"badge":"ProgressBadge_badge__C2pec"};